// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles-m__icon---2leVm","like":"styles-m__like---21lIN","liked":"styles-m__liked---3tPra"};